"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetDeactivationParams = resetDeactivationParams;
function resetDeactivationParams(serviceReferenceManager, deactivationParams) {
    deactivationParams.getBindings =
        serviceReferenceManager.bindingService.get.bind(serviceReferenceManager.bindingService);
    deactivationParams.getBindingsFromModule =
        serviceReferenceManager.bindingService.getByModuleId.bind(serviceReferenceManager.bindingService);
    deactivationParams.getDeactivations =
        serviceReferenceManager.deactivationService.get.bind(serviceReferenceManager.deactivationService);
}
//# sourceMappingURL=resetDeactivationParams.js.map